import { type IEditFaq, type IFaqData } from '@App/types/faqTypes'

import { FaqItem } from './FaqItem/FaqItem'
import { FaqListEmpty } from './FaqItem/FaqListEmpty/FaqListEmpty'
import style from './List.module.scss'

interface IProps {
    list: IEditFaq[]
    highlited: string | null
    onGetUnchangedFaqItemById: ({ id }: { id: string }) => void
    setFaqEditableState: (data: IEditFaq[] | null) => void
    updateFaqList: (dto: IFaqData) => void
    removeFaqById: (faqId: string) => void
    onDragStartHandler: (e: any, item: IEditFaq) => void
    onDragLeaveHandler: (e: any, id: string) => void
    onDragEndHandler: (e: any) => void
    onDragOverHandler: (e: any, id: string) => void
    onDropHandler: (e: any, item: IEditFaq) => void
}

export const List = (props: IProps) => {
    const {
        list,
        highlited,
        updateFaqList,
        removeFaqById,
        setFaqEditableState,
        onGetUnchangedFaqItemById,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler,
        onDropHandler
    } = props

    const resultDto = list.map(({ isEdit, ...rest }) => rest)

    return (
        <div className={style.container}>
            {list.length < 1 && <FaqListEmpty />}
            {list.length > 0 &&
                list.map((item) => {
                    const { id } = item

                    const onHandleIsEditClose = (id: string, isEdit: boolean) => {
                        // const onSuccess = () => setFaqEditableState(list.map((item) => ({ ...item, isEdit: false })))
                        onGetUnchangedFaqItemById({ id })
                    }

                    const onOpenEdit = () => {
                        setFaqEditableState(
                            list.map((item) =>
                                item.id === id ? { ...item, isEdit: true } : { ...item, isEdit: false }
                            )
                        )
                    }

                    return (
                        <FaqItem
                            key={id}
                            onHandleIsEditClose={onHandleIsEditClose}
                            onOpenEdit={onOpenEdit}
                            list={list}
                            setFaqEditableState={setFaqEditableState}
                            updateFaqList={updateFaqList}
                            removeFaqById={removeFaqById}
                            dto={resultDto}
                            onDragStartHandler={onDragStartHandler}
                            onDragLeaveHandler={onDragLeaveHandler}
                            onDragEndHandler={onDragEndHandler}
                            onDragOverHandler={onDragOverHandler}
                            onDropHandler={onDropHandler}
                            highlited={highlited}
                            {...item}
                        />
                    )
                })}
        </div>
    )
}
